import { termosStep } from '../../shared/termosSections';
import { inscricaoReferenciaSection, porCategoriaOuInscricaoReferencia } from '../../shared/juntadaSections';

const pedidoJuntadaReconsideracaoConfig = {
  id: 'pedido_JuntadaReconsideracao',
  nome: 'Pedido de Juntada de Reconsideração',
  categoria: 'pedidos',
  descricao: 'Solicitação de juntada de reconsideração',
  icon: 'FaTrashAlt',

  documentConfig: {
    documentosAdicionais: true,
    required: [
      { 
        id: 'manifestacao_reconsideracao', tipoDocumentoProcesso: 490, 
        name: 'Manifestação da Reconsideração', 
        description: 'Documento contendo a manifestação da reconsideração.', 
        required: true 
      },
    ],
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: porCategoriaOuInscricaoReferencia({ 'ADVOGADO(A)': '283', 'ESTAGIÁRIO(A)': '287' }),
    tiposAssunto: '838',
    tipoPedido: porCategoriaOuInscricaoReferencia({ 'ADVOGADO(A)': '484', 'ESTAGIÁRIO(A)': '487' })
  },

  // Confirmado ao vivo contra GET /modelo-requerimento/{283,287}/campos: só 2 campos.
  dadosRequerimentoConfig: {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'cpf', campoNome: 'CPFCNPJ' }
    ]
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
        inscricaoReferenciaSection
      ]
    },
    termosStep()
  ]
};

export default pedidoJuntadaReconsideracaoConfig;